import React, { useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import PropertyDetails from "../../components/RoomListView/PropertyDetails";
import OwnerRecDetails from "../../components/RoomListView/OwnerRecDetails";
import UserDetails from "../../components/RoomListView/UserDetails";
import BookingDetails from "../../components/RoomListView/BookingDetails";
import PriceDetails from "../../components/RoomListView/PriceDetails";
import TransactionDetails from "../../components/RoomListView/TransactionDetails";
import CouponAmount from "../../components/RoomListView/CouponAmount";
import PriceOwnerAdmin from "../../components/RoomListView/PriceOwnerAdmin";

const RoomListView = () => {
  const [specialDate, setSpecialDate] = useState(false);

  return (
    <div>
      <Topbar header={"Booking List View"} subHead={"Overall Properties"} />
      <div className="d-flex flex-wrap gap-5 mt-4">
        <PropertyDetails />
        <OwnerRecDetails />
        <UserDetails />
        <BookingDetails
          specialDate={specialDate}
          setSpecialDate={setSpecialDate}
        />
        <PriceDetails />
        <TransactionDetails />
        <CouponAmount
          specialDate={specialDate}
          setSpecialDate={setSpecialDate}
        />
        <PriceOwnerAdmin />
      </div>
    </div>
  );
};

export default RoomListView;
